import { Routes } from '@angular/router'
import { LoginComponent } from './login/login.component'
import { HomeComponent } from './sections/home/home.component'
import { UsersComponent } from './sections/users/users.component'
import { MastersComponent } from './sections/masters/masters.component'
import { AddClientComponent } from './sections/client/add-client/add-client.component'
import { ViewClientsComponent } from './sections/client/view-clients/view-clients.component'
import { CountryMasterComponent } from './sections/masters/country.master/country.master.component'
import { CurrencyMasterComponent } from './sections/masters/currency.master/currency.master.component'
import { DeliveredToMasterComponent } from './sections/masters/deliveredTo.master/deliveredTo.master.component'
import { DeliveryTimeMasterComponent } from './sections/masters/deliveryTime.master/deliveryTime.master.component'
import { MaterialMasterComponent } from './sections/masters/material.master/material.master.component'
import { MtcTypeMasterComponent } from './sections/masters/mtcType.master/mtcType.master.component'
import { PaymentTypeMasterComponent } from './sections/masters/paymentType.master/paymentType.master.component'
import { ProductMasterComponent } from './sections/masters/product.master/product.master.component'
import { QuotationCloseReasonMasterComponent } from './sections/masters/quotationCloseReason.master/quotationCloseReason.master.component'
import { TransportModeMasterComponent } from './sections/masters/transportMode.master/transportMode.master.component'
import { ValidityMasterComponent } from './sections/masters/validity.master/validity.master.component'
import { AddMemberComponent } from './sections/member-client/add-member/add-member.component'
import { ViewMembersComponent } from './sections/member-client/view-members/view-members.component'
import { AddQuotationComponent } from './sections/quotation/addQuotation/addQuotation.component'
import { ViewAllQuotationsComponent } from './sections/quotation/viewAllQuotations/viewAllQuotations.component'
import { ViewFollowUpsComponent } from './sections/quotation/viewFollowUps/viewFollowUps.component'
import { ViewQuotationDetailComponent } from './sections/quotation/viewQuotationDetail/viewQuotationDetail.component'
import { FollowupComponent } from './sections/quotation/viewQuotationDetail/viewQuotationDetailComponents/followup/followup.component'
import { ViewFollowUpDetailComponent } from './sections/quotation/viewFollowUpDetail/viewFollowUpDetail.component'
import { HsnMasterComponent } from './sections/masters/hsn.master/hsn.master.component'
import { AddVendorComponent } from './sections/vendor/add-vendor/add-vendor.component'
import { ViewVendorsComponent } from './sections/vendor/view-vendors/view-vendors.component'
import { ViewVendorMembersComponent } from './sections/member-vendor/view-vendor-members/view-vendor-members.component'
import { AddVendorMemberComponent } from './sections/member-vendor/add-vendor-member/add-vendor-member.component'
import { AddPurchaseOrderComponent } from './sections/purchaseOrder/addPurchaseOrder/addPurchaseOrder.component'
import { ViewPurchaseOrderComponent } from './sections/purchaseOrder/viewPurchaseOrder/viewPurchaseOrder.component'
import { CreateWorkOrderComponent } from './sections/workOrder/create-work-order/createWorkOrder.component'
import { PartNumberComponent } from './sections/masters/partNumber.master/partNumber.component'
import { ViewWorkOrderComponent } from './sections/workOrder/viewWorkOrder/viewWorkOrder.component'
import { WorkOrderStatusComponent } from './sections/workOrder/work-order-status/work-order-status.component'

export const routes: Routes = [
  {
    path: 'masters',
    component: MastersComponent,

    children: [
      { path: 'product', component: ProductMasterComponent, pathMatch: 'full' },
      {
        path: 'material',
        component: MaterialMasterComponent,
        pathMatch: 'full',
      },
      {
        path: 'deliveredTo',
        component: DeliveredToMasterComponent,
        pathMatch: 'full',
      },
      {
        path: 'deliveryTime',
        component: DeliveryTimeMasterComponent,
        pathMatch: 'full',
      },
      {
        path: 'hsn',
        component: HsnMasterComponent,
        pathMatch: 'full',
      },
      {
        path: 'paymentType',
        component: PaymentTypeMasterComponent,
        pathMatch: 'full',
      },
      {
        path: 'validity',
        component: ValidityMasterComponent,
        pathMatch: 'full',
      },
      {
        path: 'currency',
        component: CurrencyMasterComponent,
        pathMatch: 'full',
      },
      { path: 'country', component: CountryMasterComponent, pathMatch: 'full' },
      { path: 'mtcType', component: MtcTypeMasterComponent, pathMatch: 'full' },
      {
        path: 'transportMode',
        component: TransportModeMasterComponent,
        pathMatch: 'full',
      },
      {
        path: 'quotationCloseReason',
        component: QuotationCloseReasonMasterComponent,
        pathMatch: 'full',
      },
    ],
  },
  { path: 'addClient', component: AddClientComponent, pathMatch: 'full' },
  { path: 'viewClients', component: ViewClientsComponent, pathMatch: 'full' },
  { path: 'addMember', component: AddMemberComponent, pathMatch: 'full' },
  { path: 'viewMembers', component: ViewMembersComponent, pathMatch: 'full' },
  { path: 'addQuotation', component: AddQuotationComponent, pathMatch: 'full' },
  {
    path: 'editQuotation',
    component: AddQuotationComponent,
    pathMatch: 'full',
  },
  {
    path: 'viewQuotations',
    component: ViewAllQuotationsComponent,
    pathMatch: 'full',
  },
  {
    path: 'viewQuotationDetails/:id',
    component: ViewQuotationDetailComponent,
    pathMatch: 'full',
  },
  {
    path: 'viewFollowUps',
    component: ViewFollowUpsComponent,
    pathMatch: 'full',
  },
  {
    path: 'viewFollowUp/:id',
    component: FollowupComponent,
    pathMatch: 'full',
  },
  {
    path: 'viewFollowUpDetails/:id',
    component: ViewFollowUpDetailComponent,
    pathMatch: 'full',
  },
  { path: 'users', component: UsersComponent, pathMatch: 'full' },
  { path: '', component: HomeComponent, pathMatch: 'full' },
  {
    path: 'auth/login',
    component: LoginComponent,
    pathMatch: 'full',
  },
  { path: 'addVendor', component: AddVendorComponent, pathMatch: 'full' },
  { path: 'viewVendors', component: ViewVendorsComponent, pathMatch: 'full' },
  {
    path: 'addVendorMember',
    component: AddVendorMemberComponent,
    pathMatch: 'full',
  },
  {
    path: 'viewVendorMembers',
    component: ViewVendorMembersComponent,
    pathMatch: 'full',
  },
  {
    path: 'addPurchaseOrder',
    component: AddPurchaseOrderComponent,
    pathMatch: 'full',
  },
  {
    path: 'editPurchaseOrder',
    component: AddPurchaseOrderComponent,
    pathMatch: 'full',
  },
  {
    path: 'viewPurchaseOrders',
    component: ViewPurchaseOrderComponent,
    pathMatch: 'full',
  },
  {
    path: 'addWorkOrder',
    component: CreateWorkOrderComponent,
    pathMatch: 'full',
  },
  {
    path: 'editWorkOrder',
    component: CreateWorkOrderComponent,
    pathMatch: 'full',
  },
  {
    path: 'viewAllWorkOrders',
    component: ViewWorkOrderComponent,
    pathMatch: 'full',
  },
  {
    path: 'viewWorkOrdersStatus',
    component: WorkOrderStatusComponent,
    pathMatch: 'full',
  },
  {
    path: 'partNumber',
    component: PartNumberComponent,
    pathMatch: 'full',
  },
]
